export default __webpack_public_path__ + "static/logo-sushi-petit-prince-33aa483387821e01f75df1c2a65ca68a.svg";